<div
  class="container"
  *ngIf="toastService.showToast$ | async"
  [@toastTrigger]="(toastService.showToast$ | async) ? 'open' : 'close'"
  [class]="toastService.toastState$ | async"
>
  <div class="col-12 d-flex align-items-start toast-container m-0">
    <div class="pt-8 align-items-start justify-content-center">
      <img
        *ngIf="(toastService.toastState$ | async) == 'success-toast'"
        src="assets/img/svg/CheckCircleOutlined.svg"
      />
      <img
        *ngIf="(toastService.toastState$ | async) == 'warning-toast'"
        src="assets/img/svg/WarningAmberOutlined.svg"
      />
      <img
        *ngIf="(toastService.toastState$ | async) == 'danger-toast'"
        src="assets/img/svg/ErrorOutlineOutlined.svg"
      />
    </div>
    <div class="toastText align-items-center justify-content-center">
      <div class="pt-8">
        <span *ngIf="(toastService.toastState$ | async) == 'success-toast'" class="title color-success">{{ toastService.toastTitle$ | async }}</span>
        <span *ngIf="(toastService.toastState$ | async) == 'warning-toast'" class="title color-warning">{{ toastService.toastTitle$ | async }}</span>
        <span *ngIf="(toastService.toastState$ | async) == 'danger-toast'" class="title color-danger">{{ toastService.toastTitle$ | async }}</span>
      </div>
      <div class="mt-2 pb-8">
        <span *ngIf="(toastService.toastState$ | async) == 'success-toast'" class="message color-success">{{ toastService.toastMessage$ | async }}</span>
        <span *ngIf="(toastService.toastState$ | async) == 'warning-toast'" class="message color-warning">{{ toastService.toastMessage$ | async }}</span>
        <span *ngIf="(toastService.toastState$ | async) == 'danger-toast'" class="message color-danger">{{ toastService.toastMessage$ | async }}</span>
      </div>
    </div>
    <div class=" pt-8 align-items-start justify-content-center">
      <button class="toast-btn-close" (click)="dismiss()">
        <img class="img-fluid" *ngIf="(toastService.toastState$ | async) =='success-toast'" src="assets/img/svg/icon-close-success.svg" />
        <img class="img-fluid" *ngIf="(toastService.toastState$ | async) =='warning-toast'" src="assets/img/svg/icon-close-warning.svg" />
        <img class="img-fluid" *ngIf="(toastService.toastState$ | async) =='danger-toast'" src="assets/img/svg/icon-close-error.svg" />
      </button>
    </div>
  </div>
</div>